import {
  BraidsImage,
  BraidsImageMobile,
  ColorsImage,
  DeprecatedBraidsImage,
  DeprecatedEyebrowsImage,
  DeprecatedEyelashesImage,
  DeprecatedHaircutImage,
  DeprecatedKidsImage,
  DeprecatedLocsImage,
  DeprecatedMensHaircutImage,
  DeprecatedNailsImage,
  DeprecatedNaturalHairImage,
  DeprecatedPedicureImage,
  DeprecatedSilkPressImage,
  DeprecatedUpdatedMakeupImage,
  DeprecatedWaxImage,
  DeprecatedWeavesImage,
  DeprecatedWigsImage,
  EyeLashesImage,
  EyeLashesImageMobile,
  HaircutImage,
  HaircutImageMobile,
  KidsImage,
  LocsImage,
  LocsImageMobile,
  MakeupImage,
  MensHaircutImage,
  MensHaircutImageMobile,
  NailsImage,
  NailsImageMobile,
  NaturalHairImage,
  NaturalHairImageMobile,
  SilkPressImage,
  SilkPressImageMobile,
  WeavesImage,
  WeavesImageMobile,
} from './constants';

import { ISearchTile } from '../SearchTile/SearchTile.types';

export const tiles: ISearchTile[] = [
  {
    source: DeprecatedBraidsImage,
    text: 'Braids',
    searchParams: { q: 'braids' },
  },
  {
    source: DeprecatedNaturalHairImage,
    text: 'Natural Hair',
    searchParams: { q: 'natural hair' },
  },
  {
    source: DeprecatedHaircutImage,
    text: 'Haircut',
    searchParams: { q: 'haircut' },
  },
  {
    source: DeprecatedMensHaircutImage,
    text: 'Men\'s Haircut',
    searchParams: { q: 'mens haircut' },
  },
  {
    source: DeprecatedLocsImage,
    text: 'Locs',
    searchParams: { q: 'locs' },
  },
  {
    source: DeprecatedSilkPressImage,
    text: 'Silk Press',
    searchParams: { q: 'silk press' },
  },
  {
    source: DeprecatedWeavesImage,
    text: 'Weaves',
    searchParams: { q: 'weaves' },
  },
  {
    source: DeprecatedEyelashesImage,
    text: 'Eyelashes',
    searchParams: { q: 'eyelash-extensions' },
  },
  {
    source: DeprecatedNailsImage,
    text: 'Nails',
    searchParams: { q: 'acrylic-nails' },
  },
];

const kidsTile: ISearchTile = {
  source: DeprecatedKidsImage,
  text: 'Kids',
  searchParams: { q: 'kids' },
};

export const tilesDesktopHomePage: ISearchTile[] = [
  ...tiles,
  kidsTile,
];

export const tilesDesktopMetroPage: ISearchTile[] = [
  ...tiles,
  kidsTile,
  {
    source: DeprecatedWigsImage,
    text: 'Wigs',
    searchParams: { q: 'wig' },
  },
  {
    source: DeprecatedUpdatedMakeupImage,
    text: 'Makeup',
    searchParams: { q: 'makeup-artist' },
  },
  {
    source: DeprecatedEyebrowsImage,
    text: 'Eyebrows',
    searchParams: { q: 'eyebrow-threading' },
  },
  {
    source: DeprecatedPedicureImage,
    text: 'Pedicure',
    searchParams: { q: 'pedicure' },
  },
  {
    source: DeprecatedWaxImage,
    text: 'Wax',
    searchParams: { q: 'waxing' },
  },
];

export const tilesMobileMetroPage: ISearchTile[] = [
  ...tiles,
  {
    source: DeprecatedWigsImage,
    text: 'Wigs',
    searchParams: { q: 'wig' },
  },
  {
    source: DeprecatedUpdatedMakeupImage,
    text: 'Makeup',
    searchParams: { q: 'makeup-artist' },
  },
  {
    source: DeprecatedEyebrowsImage,
    text: 'Eyebrows',
    searchParams: { q: 'eyebrow-threading' },
  },
];

export const newTiles: ISearchTile[] = [
  {
    source: BraidsImage,
    text: 'Braids',
    searchParams: { q: 'braids' },
  },
  {
    source: NaturalHairImage,
    text: 'Natural Hair',
    searchParams: { q: 'natural hair' },
  },
  {
    source: HaircutImage,
    text: 'Haircut',
    searchParams: { q: 'haircut' },
  },
  {
    source: MensHaircutImage,
    text: 'Men\'s Haircut',
    searchParams: { q: 'mens haircut' },
  },
  {
    source: LocsImage,
    text: 'Locs',
    searchParams: { q: 'locs' },
  },
  {
    source: SilkPressImage,
    text: 'Silk Press',
    searchParams: { q: 'silk press' },
  },
  {
    source: WeavesImage,
    text: 'Weaves',
    searchParams: { q: 'weaves' },
  },
  {
    source: EyeLashesImage,
    text: 'Eyelashes',
    searchParams: { q: 'eyelash-extensions' },
  },
  {
    source: NailsImage,
    text: 'Nails',
    searchParams: { q: 'acrylic-nails' },
  },
];

export const newMobileTiles: ISearchTile[] = [
  {
    source: BraidsImageMobile,
    text: 'Braids',
    searchParams: { q: 'braids' },
  },
  {
    source: NaturalHairImageMobile,
    text: 'Natural Hair',
    searchParams: { q: 'natural hair' },
  },
  {
    source: HaircutImageMobile,
    text: 'Haircut',
    searchParams: { q: 'haircut' },
  },
  {
    source: MensHaircutImageMobile,
    text: 'Men\'s Haircut',
    searchParams: { q: 'mens haircut' },
  },
  {
    source: LocsImageMobile,
    text: 'Locs',
    searchParams: { q: 'locs' },
  },
  {
    source: SilkPressImageMobile,
    text: 'Silk Press',
    searchParams: { q: 'silk press' },
  },
  {
    source: WeavesImageMobile,
    text: 'Weaves',
    searchParams: { q: 'weaves' },
  },
  {
    source: EyeLashesImageMobile,
    text: 'Eyelashes',
    searchParams: { q: 'eyelash-extensions' },
  },
  {
    source: NailsImageMobile,
    text: 'Nails',
    searchParams: { q: 'acrylic-nails' },
  },
];

export const newIPadTiles: ISearchTile[] = [
  ...newTiles,
  {
    source: KidsImage,
    text: 'Kids',
    searchParams: { q: 'kids' },
  },
];

export const newDesktopTiles: ISearchTile[] = [
  ...newTiles,
  {
    source: ColorsImage,
    text: 'Color',
    searchParams: { q: 'color' },
  },
  {
    source: KidsImage,
    text: 'Kids',
    searchParams: { q: 'kids' },
  },
  {
    source: MakeupImage,
    text: 'Makeup',
    searchParams: { q: 'makeup-artist' },
  },
];
